import { CONTROL, PayloadsType, TEST, VariantType } from '../utils/types';

export const Name = 'homepage-hero-salary-headline';

export type PayloadType = string;

export const Payloads: PayloadsType<PayloadType, VariantType> = {
  [CONTROL]: 'Entdecke <span>die besten Stellenangebote</span> in der Pflege und Medizin.',
  [TEST]: 'Finde Pflegejobs <span>mit bis zu 5.500 €</span> Gehalt.',
};
